import { render, staticRenderFns } from "./BloodResultProvidersFormComponent.vue?vue&type=template&id=5c15aaf9"
import script from "./BloodResultProvidersFormComponent.vue?vue&type=script&lang=js"
export * from "./BloodResultProvidersFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports